interface TextBoxHtmlProps {
	className?: string;
	html: string;
}

export const TextBoxHTML: React.FC<TextBoxHtmlProps> = ({
	className,
	html,
}) => {
	return (
		html && (
			<p
				className={`[&>ol]:ml-5 [&>ol]:!list-decimal [&>ul]:ml-5 [&>ul]:!list-disc ${className}`}
				dangerouslySetInnerHTML={{ __html: html }}
			/>
		)
	);
};

export default TextBoxHTML;
